module.exports = __webpack_public_path__ + "assets/campaign.b184ef0b.svg";